export default __webpack_public_path__ + "static/media/Passport.1e863373.svg";